import React from 'react';
import { Button } from '@onward-delivery/design';
import { Trash2 } from '@onward-delivery/design/icons';
import {
    PARTNERSHIP_STATUS,
    SETUP_STATE,
    SETUP_TYPES,
    UNKNOWN_PARTNERSHIP_STATUS,
    UNKNOWN_SETUP_STATE,
} from '../constants';
import { getShipperName } from '../utils';

const stopAnd = (fn) => (e) => {
    e.stopPropagation();
    fn();
};

/**
 * One shipper on the Shippers tab. The whole row opens it; the name is the keyboard-reachable control.
 * @param {{ partnership: Object, setup?: { webhook: string, edi: string, integrations: string } | null,
 *   disabled?: boolean, onOpen: Function, onResendInvite: Function, onDelete: Function }} props
 *   `setup` is null (or missing) while the status is unknown, and each line shows "—"
 */
const ShipperRow = ({ partnership, setup, disabled, onOpen, onResendInvite, onDelete }) => {
    const status = PARTNERSHIP_STATUS[partnership.status] || UNKNOWN_PARTNERSHIP_STATUS;

    return (
        <div
            onClick={() => onOpen(partnership)}
            className="flex cursor-pointer items-start justify-between gap-6 border-b border-border px-6 py-4 transition-colors last:border-b-0 hover:bg-muted/10"
        >
            <div className="flex min-w-0 flex-col gap-1">
                <button
                    type="button"
                    onClick={stopAnd(() => onOpen(partnership))}
                    className="self-start whitespace-normal break-words rounded-sm text-left text-base font-bold text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                >
                    {getShipperName(partnership)}
                </button>
                {SETUP_TYPES.map(({ key, label }) => {
                    const state = setup ? SETUP_STATE[setup[key]] || SETUP_STATE.DISABLED : UNKNOWN_SETUP_STATE;
                    return (
                        <span key={key} className="text-sm text-foreground">
                            {label}: <span className={state.className || undefined}>{state.label}</span>
                        </span>
                    );
                })}
            </div>
            <div className="flex items-center gap-6">
                {partnership.status === 'PENDING' && (
                    <Button size="sm" variant="outline" onClick={stopAnd(() => onResendInvite(partnership))}>
                        Resend invite
                    </Button>
                )}
                <span className={`text-base ${status.className}`}>{status.label}</span>
                <Button
                    size="sm"
                    variant="ghost"
                    aria-label={`Delete ${getShipperName(partnership)}`}
                    disabled={disabled}
                    onClick={stopAnd(() => onDelete(partnership))}
                    className="text-destructive"
                >
                    <Trash2 className="h-5 w-5" />
                </Button>
            </div>
        </div>
    );
};

export default ShipperRow;
